import { Alert, Button, Stack, Typography } from '@mui/material';
import { ContentBox } from '@/components/shared/content-box';
import { useNotification } from '@/context/notification';
import type { BankSlipPaymentData } from '@/data/catalog/offer/interfaces';
import { useCheckoutWizard } from '@/packages/courses/pages/checkout/hooks/useCheckoutWizard';
import { CheckoutStepIds } from '@/packages/courses/pages/checkout/types';

export const BankSlipPaymentDetails = () => {
  const { values } = useCheckoutWizard();
  const paymentData = values[CheckoutStepIds.PixBankSlip]
    ?.paymentData as BankSlipPaymentData;
  const pdf = paymentData?.pdf ?? '';
  const { toast } = useNotification();

  const handleCopyCode = () => {
    navigator.clipboard.writeText(paymentData?.line ?? '');
    toast({
      content: 'Código copiado para a área de transferência',
      type: 'success',
    });
  };

  const handlePrintBoleto = () => window.open(pdf);

  return (
    <ContentBox spacing={2}>
      <Typography variant="h3">Instruções de pagamento</Typography>
      <Typography color="neutral.700">
        Para pagar pelo Internet Banking, copie a linha digitável ou escaneie o
        código de barras. Para pagar em qualquer banco, caixa eletrônico ou
        lotérica, por favor, imprima o boleto.
      </Typography>
      <Alert severity="info">
        Aprovação em 1 ou 2 dias úteis. Os pagamentos feitos nos fins de semana
        ou feriados serão aprovados no dia útil seguinte.
      </Alert>
      <Stack justifyContent="center" alignItems="center" my={1}>
        <img src={paymentData?.barcode ?? ''} alt="Boleto" width="100%" />
        <Typography
          textAlign="center"
          sx={{ overflowWrap: 'break-word', wordBreak: 'break-all' }}
        >
          {paymentData?.line ?? ''}
        </Typography>
      </Stack>
      <Stack direction={{ md: 'row' }} justifyContent="center" gap={2}>
        <Button variant="contained" onClick={handleCopyCode}>
          Copiar código de barras
        </Button>
        <Button variant="outlined" onClick={handlePrintBoleto}>
          Imprimir boleto
        </Button>
      </Stack>
    </ContentBox>
  );
};
